/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-statements */
/* eslint-disable no-mixed-spaces-and-tabs */
import { useEffect, useRef, useState } from 'react';
import React from 'react';
import { BsCheck2Circle } from 'react-icons/bs';
import {
	QueryClient,
	QueryClientProvider,
	useInfiniteQuery,
	useMutation
} from 'react-query';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { useDispatch } from 'react-redux';
import { globalEnv } from '../../../../config/baseConfig';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import LazyImage from '../../../Utils/Components/lazyImageComponent';
import LoadingSquaresAnimation from '../../../Utils/LoadingAnimations/LoadingSqauresAnimation';
import axiosInstance from '../../../../config/axiosInstance';
import SaveButton from '../../../Utils/saveButton';
import LoadingRectanglesAnimation from '../../../Utils/LoadingAnimations/LoadingRectanglesAnimation';
import placeholder from '../../../../assets/images/placeholder.png';

const queryClient = new QueryClient();

type props = {
	setOpen: (isOpen: boolean) => void;
	imageId: string | undefined;
	topicId: string | undefined;
	editorId: string;
};

export default function CopyToTopicModalContent({
	setOpen,
	imageId,
	topicId,
	editorId
}: props) {
	const cancelButtonRef = useRef(null);

	const [isPaused, setPause] = useState(false);
	const [addedTopics, setAddedTopics] = useState<any[]>([]);
	const [isSaving, setIsSaving] = useState(false);
	const { searchQuery } = useTypedSelector((state) => state.searchbar);

	const dispatch = useDispatch();

	const fetchTopics = async ({ pageParam = 1 }) => {
		const { data } = await axiosInstance().get(
			`${globalEnv.BASE_URL}/editor/${editorId}/get-details?page=${pageParam}&isLongList=true`
		);
		return {
			data,
			nextPage: pageParam + 1,
			totalPages: data.meta.pages
		};
	};

	const { data, isLoading, isFetching, isError, fetchNextPage } =
		useInfiniteQuery([searchQuery], fetchTopics, {
			getNextPageParam: (lastPage) => {
				if (lastPage.nextPage <= lastPage.totalPages) return lastPage.nextPage;
				return undefined;
			}
		});

	const listInnerRef = useRef<null>(null);

	const onScroll = () => {
		if (!isFetching) {
			if (listInnerRef.current) {
				const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
				if (scrollTop + clientHeight >= scrollHeight - 600) {
					if (!isPaused) {
						fetchNextPage();
						setPause(true);
					}
				} else undoPause();
			}
		}
	};

	const undoPause = () => {
		setTimeout(() => {
			setPause(false);
		}, 1000);
	};

	const checkIfTopicIsSelected = (id: string) => {
		return addedTopics.some((e: any) => e._id === id) ? true : false;
	};

	const copyImageToTopicsReq = async () => {
		const dto = {
			updatedTopics: addedTopics.map((item) => item._id),
			imageId: imageId
		};

		// const config = {
		// 	headers: {
		// 		Authorization: 'Bearer ' + ACCESS_TOKEN
		// 	}
		// };
		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + `/editor/topic/${topicId}/copy-image-to-topics`,
			dto
			// config
		);
		return response;
	};

	const copyImageToTopics = useMutation(copyImageToTopicsReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully copied image.'
				})
			);
			setOpen(false);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<div
				className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
					 w-10/12 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
			>
				<section
					onScroll={() => onScroll()}
					ref={listInnerRef}
					className="relative bg-white w-full max-h-screen overflow-y-auto h-full 
									dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
				>
					<div className="w-full mx-auto ">
						<div className="flex flex-wrap -m-1 md:-m-2 w-full md:px-4 py-4 lg:px-[2%] px-[3%]">
							{isLoading ? (
								<div
									className="container mx-auto mb-3 
									grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-4"
								>
									<LoadingRectanglesAnimation />
								</div>
							) : isError ? (
								<p>There was an error</p>
							) : (
								data?.pages.map((page) =>
									page.data.createdTopics.topics.map((item: any) => (
										<SingleTopic
											key={item._id}
											item={item}
											isSelected={checkIfTopicIsSelected(item._id)}
											addedTopics={addedTopics}
											setAddedTopics={setAddedTopics}
										/>
									))
								)
							)}
							{isFetching && (
								<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-items-center gap-4">
									<LoadingSquaresAnimation />
								</div>
							)}
						</div>
					</div>
				</section>
				<div
					className="flex flex-row justify-end pt-3 pb-2 px-6 space-x-2 -mt-1
						bg-white dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
				>
					<button
						type="button"
						className="btn btn-outline btn-sm btn-error mr-2"
						onClick={() => setOpen(false)}
						ref={cancelButtonRef}
					>
						Cancel
					</button>
					{addedTopics.length > 0 && (
						<SaveButton
							isSaving={isSaving}
							saveFunc={() => copyImageToTopics.mutate()}
							text={'Copy'}
						/>
					)}
				</div>
			</div>
		</QueryClientProvider>
	);
}

type singleTopicProps = {
	item: any;
	isSelected: boolean;

	addedTopics: any[];
	setAddedTopics: (item: any) => void;
};

const SingleTopic = (props: singleTopicProps) => {
	const [isSelected, setSelected] = useState(props.isSelected);
	const [random] = useState(Math.floor(Math.random() * 101));

	const updateSelect = () => {
		if (!isSelected) props.setAddedTopics([...props.addedTopics, props.item]);
		else {
			props.setAddedTopics(
				props.addedTopics.filter((item) => item._id !== props.item._id)
			);
		}
		setSelected(!isSelected);
	};

	return (
		<div
			className="flex flex-wrap flex-col w-1/3 p-4"
			onClick={() => updateSelect()}
		>
			<div className="relative rounded-lg flex justify-center content-center w-full aspect-[16/10] dark:bg-gray-600 bg-gray-300 mb-2">
				<LazyImage
					photo={
						props.item.backgroundImage.url_low_res != undefined
							? props.item.backgroundImage.url_low_res
							: placeholder
					}
					style={
						'block object-cover object-center w-full aspect-[16/10] rounded-lg'
					}
					loaderDimesnions={80}
					effect={'blur'}
				/>
				<div
					className={
						isSelected
							? 'absolute inset-0 bg-gradient-to-t rounded-lg from-black/75 opacity-100 text-center transition-colors duration-500'
							: 'absolute inset-0 bg-gradient-to-t rounded-lg from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center'
					}
				></div>
				{isSelected ? (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-gray-100 dark:text-primary text-center transition-all duration-500 opacity-100"
					/>
				) : (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-gray-100 mx-2 dark:text-primary text-center transition-all duration-500 opacity-0 scale-0"
					/>
				)}
			</div>
			<h3 className="font-medium text-center dark:text-white">
				{props.item.name}
			</h3>
		</div>
	);
};
